export const cleanPhone = (phone) => {
  return phone.replace(/[^0-9]/g, '').trim().replace('+', '')
}

export const normalizeRut = (rut = '') => {
  return String(rut)
    .replaceAll(' ', '')
    .replaceAll('.', '')
    .toUpperCase()
}